import React from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import common from '../../assets/common/CommonStyle.module.css';
import {useTranslation} from 'react-i18next';
import CommonReportTable from './components/CommonReportTable';
import SimpleReportTable from './components/SimpleReportTable';
import {
	useGetFinNoPointsQuery,
	useGetFinOthersQuery,
	useGetFinPointsQuery,
	useGetFinSpecnonpointsQuery,
	useGetFinVolonterQuery,
} from '../../redux/DepotSlice/depotReportApi';
import {monthNow} from '../../assets/utils/dateUtils';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import StatisticsTable from './components/StatisticsTable';
import FinBalancePointProducts from './components/FinBalancePointProducts';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const FinancialReport = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();

	const month = monthNow();

	const {
		data: finPointsList,
		isLoading: isLoadingFinPoints,
		isError: isErrorPointsList,
		error: errorPointsList,
	} = useGetFinPointsQuery(month, {
		skip: !restrictions.canAccessFinancialReport,
	});
	const {
		data: finNoPointsList,
		isLoading: isLoadingFinNoPoints,
		isError: isErrorNoPointsList,
		error: errorNoPointsList,
	} = useGetFinNoPointsQuery(month, {
		skip: !restrictions.canAccessFinancialReport,
	});
	const {
		data: finVolonterList,
		isLoading: isLoadingFinVolonter,
		isError: isErrorFinVolonterList,
		error: errorFinVolonterList,
	} = useGetFinVolonterQuery(month, {
		skip: !restrictions.canAccessFinancialReport,
	});
	const {
		data: finOthersList,
		isLoading: isLoadingFinOthers,
		isError: isErrorOthersList,
		error: errorOthersList,
	} = useGetFinOthersQuery(month, {
		skip: !restrictions.canAccessFinancialReport,
	});
	const {
		data: finSpecnonpoints,
		isLoading: isLoadingSpecnonpoints,
		isError: isErrorSpecnonpoints,
		error: errorSpecnonpoints,
	} = useGetFinSpecnonpointsQuery(month, {
		skip: !restrictions.canAccessFinancialReport,
	});

	if (!restrictions.canAccessFinancialReport) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Фінансовий звіт')} />

			<FinBalancePointProducts />

			{!isLoadingFinPoints && finPointsList ? (
				<CommonReportTable
					title={t('Облік балової продукції')}
					data={finPointsList.reports}
				/>
			) : isErrorPointsList && errorPointsList && 'data' in errorPointsList ? (
				<div className={common.error}>
					{errorPointsList.data.message.textmsg}
				</div>
			) : (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			)}
			{!isLoadingFinNoPoints && finNoPointsList ? (
				<CommonReportTable
					title={t('Облік не балової продукції')}
					data={finNoPointsList.reports}
				/>
			) : isErrorNoPointsList &&
			  errorNoPointsList &&
			  'data' in errorNoPointsList ? (
				<div className={common.error}>
					{errorNoPointsList.data.message.textmsg}
				</div>
			) : (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			)}
			{!isLoadingFinVolonter && finVolonterList ? (
				<SimpleReportTable
					title={t('Облік благодійності')}
					data={finVolonterList.reports}
					columns={[
						'Дата початок',
						'Дата кінець',
						'Баланс на початок',
						'Проведено',
						'Надходження кас. ордер',
						'Баланс на кінець',
					]}
					fields={[
						'start_date',
						'end_date',
						'balance_start',
						'sold',
						'paid_order',
						'balance_end',
					]}
					columnsCount={6}
				/>
			) : isErrorFinVolonterList &&
			  errorFinVolonterList &&
			  'data' in errorFinVolonterList ? (
				<div className={common.error}>
					{errorFinVolonterList.data.message.textmsg}
				</div>
			) : (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			)}
			{!isLoadingFinOthers && finOthersList ? (
				<SimpleReportTable
					title={t('Облік рахунку Інше')}
					data={finOthersList.reports}
					columns={[
						'Дата початок',
						'Дата кінець',
						'Баланс на початок',
						'Прийшло',
						'Витрати',
						'Баланс на кінець',
					]}
					fields={[
						'start_date',
						'end_date',
						'balance_start',
						'sold',
						'sold_sale',
						'balance_end',
					]}
					columnsCount={6}
				/>
			) : isErrorOthersList && errorOthersList && 'data' in errorOthersList ? (
				<div className={common.error}>
					{errorOthersList.data.message.textmsg}
				</div>
			) : (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			)}
			{!isLoadingSpecnonpoints && finSpecnonpoints ? (
				<SimpleReportTable
					title={t('Облік ексклюзивних товарів')}
					data={finSpecnonpoints.reports}
					columns={[
						'Дата початок',
						'Дата кінець',
						'Баланс на початок',
						'Надійшло',
						'Повернуто',
						'Надходження кас. ордер',
						'Баланс на кінець',
					]}
					fields={[
						'start_date',
						'end_date',
						'balance_start',
						'sold',
						'sold_sale',
						'paid_order',
						'balance_end',
					]}
					columnsCount={7}
				/>
			) : isErrorSpecnonpoints &&
			  errorSpecnonpoints &&
			  'data' in errorSpecnonpoints ? (
				<div className={common.error}>
					{errorSpecnonpoints.data.message.textmsg}
				</div>
			) : (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			)}
			{/*<ReportFinBalanceProductTable />*/}
			<StatisticsTable />
		</div>
	);
};

export default FinancialReport;
